<template>
  <div class="etr">
    <b-card class="mt-3">
      <b-card-header v-if="selection[0]">
        <b-row align-v="center" no-gutters>
          <b-col cols="11">
            <b-button-group>
              <!-- <b-button
                v-print="'#paper'"
                squared
                size="sm"
                class="mr-4"
                title="Print"
              >
                <i class="fa fa-print pr-3"></i>Print
              </b-button> -->
              <div class="inline-block">
                <i :class="'fa fa-gbp fa-2x mr-1 text-primary'"></i>
                <span class="h4 ml-1">{{ item.ref }}</span>
              </div>
            </b-button-group>
          </b-col>

          <b-col cols="1" class="text-right">
            <b-button-group>
              <!-- <b-button
                class="mr-1"
                squared
                size="sm"
                variant="primary"
                @click="download()"
              >
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button> -->

              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left "></i>Back
              </b-button></b-button-group>
          </b-col>
        </b-row>
      </b-card-header>

      <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
        <r-invoice :showasdraft="true" :item="item" />
        <b-alert v-if="item.message" show :variant="item.level" class="text-center mt-2 mb-1">
          <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
              <i class="fa fa-info-circle fa-2x"></i></b-col>
            <b-col> <span v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
        </b-alert>
      </b-overlay>
      <b-card-footer class="mt-2  ml-1">
        <b-row class="mb-2">
          <b-col class="text-left">
            <b-row class="mt-1">
              <b-col>
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                  <span class="text-success ml-2">Preparing set of invoice(s)</span>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="text-right">
            <b-button-group class="z-0" v-if="items.length > 1">
              <b-button squared size="sm" @click="render()" variant="outline-primary" class="mr-1 h-28px">
                <i class="fa fa-refresh"></i>
              </b-button>

              <b-pagination hide-ellipsis v-model="page" :total-rows="ss.length" :per-page="1" align="right"
                size="sm"></b-pagination>
            </b-button-group>


          </b-col>

        </b-row>

        <b-row>
          <b-col cols="12" sm="6" md="6" xl="6">
            <b-form-group label="Showing invoice(s) with only:" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group class="relative z-0" v-model="level" :options="options_level"
                :aria-describedby="ariaDescribedby" value-field="id" text-field="label"></b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="6" xl="6">
            <b-form-group label="Email drafting logs to" label-for="email" label-cols="12">
              <b-input-group>
                <b-form-input type="text" v-model="emailto" placeholder="Email" size="sm"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="emailto = ''">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>

                <b-button squared size="sm" @click="render(emailto)" variant="primary">
                  <i class="fa fa-paper-plane pr-3"></i>Send
                </b-button>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <b-col v-if="user.permissions.includes('salesledger.save')" class="mt-3 text-left">
            <b-button :disabled="posted" squared size="sm" variant="primary" @click="postit()" class="mr-1">
              <i class="fa fa-check"></i>
              Post It
            </b-button>
            <b-button squared size="sm" class="ml-1" variant="warning" @click="showledgers = !showledgers"
              :pressed="!showledgers">
              Ledgers<i :class="showledgers ? 'fa fa-arrow-up ml-1' : 'fa fa-arrow-down ml-1'
                "></i>
            </b-button>

          </b-col>
          <b-col class="mt-3 text-right">
            <b-button squared size="sm" class="mr-0" variant="secondary" @click="$emit('discard')">
              <i class="fa fa-chevron-left"></i>Back
            </b-button>
          </b-col>

        </b-row>
      </b-card-footer>
      <div v-if="showledgers" class="mx-4">
        <b-row>
          <b-card class="border-none w-100pct">
            <b-card-title class="text-left">B/L Item Headers</b-card-title>
            <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.BL" :showpages="false"
              :showtoolbar="false">
            </d-table>
          </b-card>
        </b-row>
        <b-row>
          <b-card class="border-none w-100pct">
            <b-card-title class="text-left">S/L Item Headers</b-card-title>
            <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="SL" :showpages="false"
              :showtoolbar="false">
            </d-table> </b-card></b-row>
        <b-row>
          <b-card class="border-none w-100pct">
            <b-card-title class="text-left">l Item Lines</b-card-title>
            <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.SL[0].items"
              :showpages="false" :showtoolbar="false">
            </d-table> </b-card></b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "TicketsDraft",
  props: {
    queued: { type: Boolean, default: false },
    intray: { type: String, default: "" },
  },
  mounted() {
    this.emailto = this.user.email;
  },
  data() {
    return {
      busy: false,
      posted: false,
      emailto: null,
      sendmail: false,
      message: "",
      page: 1,
      level: ["success"],
      ss: [],
      items: [],
      item: {
        ref: ""
      },
      draft: {
        items: [],
      },
      data: null,
      SL: [],
      showledgers: false,
      options_level: [
        { id: "success", label: "Success" },
        { id: "warning", label: "Warning" },
        { id: "danger", label: "Danger" },
      ],
    };
  },
  watch: {
    selection: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:selection", newVal);
          
          this.draft.items = newVal;
          await this.render();
          this.posted = false;
        }
      },
    },
    level: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.changeFilter()
          // this.posted = false;
        }
      },
    },
    page: {
      async handler(newVal, oldVal) {
        if (newVal) {
          if (newVal <= this.ss.length) {
            this.item = this.ss[newVal - 1];

            if (this.item.data) {
              this.data = JSON.parse(this.item.data);
              this.SL = [];
              this.SL.push({ ...this.data.SL[0] });
              delete this.SL[0].items;
            }
          }
        }
      },
    },
  },
  methods: {
    async render(emailto) {
      this.busy = true;

      let variables = {
        selected: this.queued ? null : this.draft.items,
        queued: this.queued ? this.draft.items : null,
        intray: this.intray,
        // level: this.level ? this.level.join(",") : null,
        emailto: emailto ? this.emailto : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets_draftinvoice(
              $selected: [Ticket_input]
              $queued: [Queue_input]
              $intray: String
              $level: String
              $emailto: String
            ) {
              tickets_draftinvoice(
                selected: $selected
                queued: $queued
                intray: $intray
                level: $level
                emailto: $emailto
              ) {
                ref
                to
                address
                dateref
                slac
                agent
                yourref
                eventname
                vatregion
                saletotal
                terms
                credit
                id
                data
                mifields {
                  label
                  value
                }
                document {
                  fields {
                    key
                    label
                    class
                  }
                  items
                }
                message
                level
              }
            }
          `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.items = response.data.tickets_draftinvoice;
        if (this.queued) {
          this.level = ["success", "warning"]
        } else {
          this.level = ["success"]
        }
        this.changeFilter()

      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    changeFilter() {

      this.options_level.find(o => o.id == 'danger').label = "Danger ( " + this.items.filter(i => i.level == "danger").length + " )"
      this.options_level.find(o => o.id == 'warning').label = "Warning ( " + this.items.filter(i => i.level == "warning").length + " )"
      this.options_level.find(o => o.id == 'success').label = "Success ( " + this.items.filter(i => i.level == "success").length + " )"

      let sset = this.items
      if (!this.level.includes('danger')) {
        sset = sset.filter(i => i.level != "danger")
      }
      if (!this.level.includes('warning')) {
        sset = sset.filter(i => i.level != "warning")
      }
      if (!this.level.includes('success')) {
        sset = sset.filter(i => i.level != "success")
      }
      this.ss = sset

      this.message = "<span class='text-success'>" + this.ss.length
      if (this.posted) {
        this.message += " invoice(s) are posted.</span>"
      } else {
        this.message += " invoice(s) are drafted.</span>"
      }

      this.item = { ref: "" }
      if (this.ss.length > 0) {

        this.item = this.ss[0];
        this.SL = []

        if (this.item.data) {
          this.data = JSON.parse(this.item.data);
          this.SL.push({ ...this.data.SL[0] });
          delete this.SL[0].items;
        }
      }
    },
    async postit() {
      this.busy = true;

      let variables = {
        selected: this.queued ? null : this.draft.items,
        queued: this.queued ? this.draft.items : null,
        intray: this.intray,
        emailto: this.emailto ? this.emailto : null,
        apply: true,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
              query tickets_draftinvoice(
                $selected: [Ticket_input]
                $queued: [Queue_input]
                $intray: String
                $level: String
                $emailto: String
                $apply: Boolean
              ) {
                tickets_draftinvoice(
                  selected: $selected
                  queued: $queued
                  intray: $intray
                  level: $level
                  emailto: $emailto
                  apply: $apply
                ) {
                  ref
                  to
                  address
                  dateref
                  slac
                  agent
                  yourref
                  eventname
                  vatregion
                  saletotal
                  terms
                  credit
                  id
                  data
                  document {
                    fields {
                      key
                      label
                      class
                    }
                    items
                  }
                  message
                  level
                  posted
                }
              }
            `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.items = response.data.tickets_draftinvoice;
        if (response.data.tickets_draftinvoice.length > 0) {
          this.item = response.data.tickets_draftinvoice[0];
          if (this.item.data) {
            this.data = JSON.parse(this.item.data);
            this.SL.push({ ...this.data.SL[0] });
            delete this.SL[0].items;
          }
        }

      } catch (error) {
        console.log(error);
      }

      this.posted = true
      if (this.queued) {
        this.level = ["success", "warning"]
      } else {
        this.level = ["success"]
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>